import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";
import { media } from "../utils/MediaQueries";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);



function headerAnimations() {

  if (window.matchMedia('(min-width: 1280px)').matches) {

    window.addEventListener('scroll', function() {
      if ( document.documentElement.scrollTop <= 100 ) {
        document.querySelector( '.top-nav' ).classList.remove('fixed-header')
        document.querySelector( '.top-nav' ).classList.remove('show-logo')
        if (document.querySelectorAll(".js-cheam-logo-circle").length) {
          $('.js-cheam-logo-circle').addClass("z-30")
          $('.js-cheam-logo-circle').removeClass("z-100")
        }
      } else {
        document.querySelector( '.top-nav' ).classList.add('fixed-header')
        document.querySelector( '.top-nav' ).classList.add('show-logo')
        if (document.querySelectorAll(".js-cheam-logo-circle").length) {
          $('.js-cheam-logo-circle').removeClass("z-30")
          $('.js-cheam-logo-circle').addClass("z-100")
        }
      }
    });

    // Circular cheam logo stick to menu bar, change menu bg to white
    if (document.querySelectorAll(".js-cheam-logo-circle").length) {
      const logoCircle = $('.js-cheam-logo-circle');
      const logoText = $('.top-nav__logo');

      const headerTL = gsap.timeline({
        ease: 'none',
        scrollTrigger: {
          trigger: ".js-cheam-logo-circle",
          pin: true,
          pinnedContainer: "#page-wrap",
          start: "top 30px",
          end: "max",
          toggleActions: "play pause play reset",
          //markers: true,
        }
      });

      headerTL.fromTo( logoText, { opacity: 1 }, { opacity: 0, duration: 0.35 } );
      headerTL.fromTo( logoCircle, { y:0, }, { y: 0, duration: 0.1 } );
      
      var pinElement = document.querySelector('.js-cheam-logo-circle').parentNode;
      pinElement.style.pointerEvents = "none";
    }

    // For pages with mixed banner
    if (document.querySelectorAll(".banner--mixed").length) {
      window.addEventListener('scroll', function() {
        if ( document.documentElement.scrollTop <= 100 ) {
          document.querySelector( '.top-nav' ).classList.add('show-logo')
          $('.js-logo-circle').addClass("opacity-0")
          $('.js-logo-circle').removeClass("opacity-100")
        } else {
          document.querySelector( '.top-nav' ).classList.remove('show-logo')
          $('.js-logo-circle').addClass("opacity-100")
          $('.js-logo-circle').removeClass("opacity-0")
        }
      });
    }

  }
  
}


export default headerAnimations;


